import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export default class MusicPlatformService {
	public static musicPlatformSave(input: any) {
		return input?.id > 0
			? Http.axios()
					.put(`/api/StreamingPlatform/update-platform`, input?.musicsInput, {
						headers: { Authorization: getUserAccessToken() },
					})
					.then((res: any) => {
						return res;
					})
					.catch((e: any) => {
						return e.response;
					})
			: Http.axios()
					.post("/api/StreamingPlatform/add-platform", input?.musicsInput, {
						headers: { Authorization: getUserAccessToken() },
					})
					.then((res: any) => {
						return res;
					})
					.catch((e: any) => {
						return e.response;
					});
	}

	public static musicPlatformGetByFilter(input: any) {
		return Http.axios()
			.get(`/api/StreamingPlatform/Get-all-platforms`, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static musicPlatformGetDetail(id: any) {
		return Http.axios()
			.get("/api/StreamingPlatform/details/" + id, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static musicPlatformDelete(input: any) {
		return Http.axios()
			.delete("/api/StreamingPlatform/delete/" + input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
}
